<template>
  <div>
    <el-dialog
      v-model="dialogFormVisible"
      :close-on-click-modal="false"
      :title="title"
      width="60%"
      @close="close"
    >
      <el-form ref="form" label-width="120px" :model="form" :rules="rules">
        <el-form-item label="类型">
          <el-radio-group v-model="form.typehood" size="mini">
            <el-radio-button :label="1">小程序</el-radio-button>
            <el-radio-button :label="2">H5</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="标题" prop="title">
          <el-input v-model="form.title" placeholder="标题" />
        </el-form-item>
        <el-form-item label="图片列表" prop="imageList">
          <el-upload
            :multiple="true"
            :action="QNUploadURL"
            :data="uploadToken"
            list-type="picture-card"
            :file-list="form.imageList"
            :on-success="image_success"
            :on-remove="image_remove"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item v-if="form.typehood === 2" label="跳转链接" prop="actionLink">
          <el-input v-model="form.actionLink" placeholder="跳转链接" />
        </el-form-item>
        <el-form-item label="备注" prop="text">
          <el-input type="textarea" v-model="form.text" placeholder="备注" />
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="form.order" placeholder="排序" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="save">确 定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { createPage, editPage } from '@/api/display'
import { getUploadToken } from '@/api/app'
import { QNUploadURL, QNHost } from '@/config/net.config'
import { positionList } from '@/utils/const'
export default {
  name: 'LandingEdit',
  emits: ['fetch-data'],
  data() {
    return {
      title: '',
      QNUploadURL,
      uploadToken: '',
      positionList,
      form: {
        pageId: '',
        typehood: 1,
        actionLink: '',
        imageList: [],
        text: '',
        order: 1,
      },
      rules: {
        imageList: [
          {
            validator: (rule, value, callback) => {
              if (value.length == 0) {
                callback(new Error('请上传图片'))
              } else {
                callback()
              }
            },
          },
        ],
      },
      dialogFormVisible: false,
    }
  },
  methods: {
    async showEdit(row) {
      if (row) {
        this.title = '修改落地页'
        this.form = Object.assign(this.form, {
          ...row.basic,
          title: row.title,
          pageId: row.pageId,
          typehood: row.typehood || 1,
        })
      } else {
        this.title = '新增落地页'
      }
      this.dialogFormVisible = true
      const token = await getUploadToken({})
      this.uploadToken = { token: token.token }
    },
    // 图片
    image_remove(file, fileList) {
      this.form.imageList = fileList.map((e) => ({
        name: e.name,
        url: e.url,
      }))
    },
    image_success(res, file) {
      if (!res.hash) {
        this.$message.error('图片上传失败')
        return
      }
      this.form.imageList.push({
        name: file.name,
        url: QNHost + '/' + res.hash,
      })
    },
    close() {
      this.$refs['form'].resetFields()
      this.form = this.$options.data().form
      this.dialogFormVisible = false
    },
    save() {
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          const pageId = this.form.pageId
          // if (this.form.typehood === 2 && !this.form.actionLink) {
          //   this.$message.warning('请填写跳转链接')
          //   return
          // } 
          this.$baseConfirm(
            `你确定要${pageId ? '修改' : '新增'}落地页吗`,
            null,
            async () => {
              pageId
                ? await editPage(this.form)
                : await createPage(this.form)
              this.$baseMessage(
                `${pageId ? '修改' : '新增'}落地页成功`,
                'success',
                false,
                'vab-hey-message-success'
              )
              this.$emit('fetch-data')
              this.close()
            }
          )
        } else {
          return false
        }
      })
    },
  },
}
</script>

<style lang="scss">
.disabled .el-upload--picture-card {
  display: none;
}
</style>
